export default "__VITE_ASSET__9ZySaaRa__"